if (!customElements.get('product-modal')) {
  customElements.define('product-modal', class ProductModal extends ModalDialog {
    constructor() {
      super();
      this.content = this.querySelector('[role="document"]');
      this.querySelector('[data-gallery-previous]').addEventListener('click', () => this.move(-1));
      this.querySelector('[data-gallery-next]').addEventListener('click', () => this.move(1));
      this.addEventListener('keydown', (event) => {
        if (event.target.closest('deferred-media, product-model')) return;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          this.move(event.key === 'ArrowLeft' ? -1 : 1);
        }
      });
      this.content.addEventListener('touchstart', (event) => {
        this.touchStart = event.touches.length === 1 && event.target.tagName === 'IMG'
          ? { x: event.touches[0].clientX, y: event.touches[0].clientY } : null;
      }, { passive: true });
      this.content.addEventListener('touchend', (event) => {
        if (!this.touchStart || event.touches.length) return;
        const dx = event.changedTouches[0].clientX - this.touchStart.x;
        const dy = event.changedTouches[0].clientY - this.touchStart.y;
        this.touchStart = null;
        if (window.visualViewport?.scale > 1) return;
        if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.5) this.move(dx < 0 ? 1 : -1);
      }, { passive: true });
      this.content.addEventListener('touchcancel', () => { this.touchStart = null; });
    }

    show(opener) {
      super.show(opener);
      this.items = Array.from(this.content.children).filter((item) => item.hasAttribute('data-media-id'));
      const index = this.items.findIndex((item) => item.dataset.mediaId === opener.dataset.mediaId);
      this.select(index < 0 ? 0 : index);
    }

    move(direction) {
      if (!this.items?.length) return;
      this.select((this.index + direction + this.items.length) % this.items.length);
    }

    select(index) {
      if (!this.items.length) return;
      window.pauseAllMedia();
      this.index = index;
      this.items.forEach((item, position) => {
        item.classList.toggle('active', position === index);
        item.setAttribute('aria-hidden', String(position !== index));
      });
      this.content.scrollTo(0, 0);
      this.querySelector('[data-gallery-count]').textContent = `${index + 1} / ${this.items.length}`;
      this.querySelectorAll('[data-gallery-previous], [data-gallery-next]').forEach((button) => {
        button.disabled = this.items.length < 2;
      });
      const activeMedia = this.items[index];
      const template = activeMedia.querySelector('template');
      if (activeMedia.nodeName === 'DEFERRED-MEDIA' && template?.content.querySelector('.js-youtube')) {
        activeMedia.loadContent();
      }
    }
  });
}
